import * as React from 'react';
import { Component } from 'react';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Alert from '@material-ui/lab/Alert';
import AcademicYearDropDown from '../DropDowns/AcademicYearDropDown';
import EnrolmentWelcomeViewModel from '../ViewModels/EnrolmentWelcomeViewModel';
import MaterialUIPickers from '../MaterialUIPickers';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import { FormControl } from '@material-ui/core';
import ArrowForward from '@material-ui/icons/ArrowForward'

const styles = (theme: Theme) => createStyles({
    root: {
        flexGrow: 1,
        zIndex: 1,
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
        width: '100%',
        padding: '0'
    },
    gridItem: {
        padding: '0'
    },
    buttonItem: {
        marginTop: theme.spacing(2),

    },
    button: {

        //height: '56px'
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    errorText: {
        color: '#ff0000'
    }
});

interface IEnrolmentWelcomeProps {
    setModel: (model) => void;
}

interface IEnrolmentWelcomeState {
    model: EnrolmentWelcomeViewModel;
    canSave: boolean;
    saving: boolean;
    studentNotFound: boolean;
    enrolmentAlreadyComplete: boolean;
}

export class EnrolmentWelcome extends Component<IEnrolmentWelcomeProps & WithStyles<typeof styles>, IEnrolmentWelcomeState> {
    constructor(props) {
        super(props);

        this.state = {
            model: new EnrolmentWelcomeViewModel,
            canSave: false,
            saving: false,
            studentNotFound: false,
            enrolmentAlreadyComplete: false,
        };
    }

    public componentDidMount() {
        ValidatorForm.addValidationRule('isPostcodeValid', (value) => {
            return (/^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))\s[0-9][A-Za-z]{2})$/.test(value));
        });
        ValidatorForm.addValidationRule('isRefNoValid', (value) => {
            return (/^(([a-zA-Z]{3})([0-9]{8}))$/.test(value));
        });
    }

    componentWillUnmount() {
        ValidatorForm.removeValidationRule('isPostcodeValid');
        ValidatorForm.removeValidationRule('isRefNoValid');
    }

    public render() {
        const classes = this.props.classes;

        return (
            <Grid className={classes.root} container>
                <Grid item xs={12}>
                    <Grid className={classes.root} container spacing={2}>
                        <Grid item xs={12}>
                            <Typography variant="h2">
                                Enrolment
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <br />
                            <Typography>
                                Welcome to the Hull College Online Enrolment Portal.
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography>
                                We are looking forward to welcoming you to Hull College very soon.
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography>
                                To complete your enrolment, simply complete this form and submit as instructed. It should take
                                approximately 15-20 minutes to complete. If you need any additional help or information about the
                                enrolment process, fees or even access to a friendly member of staff, visit our ‘Helpful Documents’
                                page: <a href="/help" target="_blank">Hull College (hull-college.ac.uk)</a>
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography>
                                Quick and Easy Steps to Start:
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <ol>
                                <li><b>Time Needed:</b> It takes about 15-20 minutes to fill in the form.</li>
                                <li><b>For Ages 19 and Above:</b> Have your National Insurance Number ready.</li>
                                <li><b>Your Past Grades:</b> If you have them, great! If not, you can provide them later.</li>
                                <li><b>Need Help?</b> For instructions, fee details, and more about your enrolment process, visit our Helpful Documents.</li>
                                <li><b>Change of Mind?</b> To switch courses, you can either pop into the college or call our friendly Admissions team - 01482 329943.</li>
                            </ol>

                        </Grid>
                        <Grid item xs={12}>
                            <Typography>
                                Are you ready to begin? Select your academic year from the dropdown to start.
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography>
                                We are excited to welcome you to Hull College!
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12} >
                    <Grid className={this.props.classes.root} container alignItems="center" justify="center">

                        {this.state.studentNotFound &&
                            <Grid item xs={12} >
                                <Alert severity="error">We couldn't find you. Please check your details and try again.</Alert>

                            </Grid>
                        }

                        {this.state.enrolmentAlreadyComplete &&
                            <Grid item xs={12} >
                                <Alert severity="error">You have already completed the enrolment form.</Alert>

                            </Grid>
                        }

                        <Grid item xs={12}>
                            <ValidatorForm onSubmit={this.save} autoComplete="off">
                                <Grid className={classes.root} container>
                                    <Grid item xs={12}>
                                        <AcademicYearDropDown
                                            academicYear={this.state.model.academicYear}
                                            disabled={false}
                                            fromYear={parseInt(new Date().getFullYear().toString().substr(2, 2))}
                                            toYear={parseInt(new Date().getFullYear().toString().substr(2, 2))}
                                            setAcademicYearId={this.handleAcademicYearChange}
                                            documentUploadMode={false}
                                        />
                                    </Grid>


                                    {this.state.model.academicYear !== undefined &&
                                        <React.Fragment>
                                            <Grid item xs={12}>
                                                <FormControl fullWidth>
                                                    <TextValidator
                                                        label="Student Reference Number"
                                                        name="studentReferenceNumber"
                                                        title="Student Reference Number"
                                                        fullWidth
                                                        variant="outlined"
                                                        margin="normal"
                                                        value={this.state.model.studentReferenceNumber}
                                                        onChange={this.handleChange}
                                                        validators={['isRefNoValid', 'required']}
                                                        errorMessages={['Please enter a valid Student Reference Number', 'This field is required']}
                                                    />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <MaterialUIPickers
                                                    label="Date of Birth"
                                                    valueKey="dateofBirth"
                                                    updateValue={this.handleDateChange}
                                                    date={this.state.model.dateofBirth}
                                                    endDate={new Date(new Date().getFullYear() - 13, new Date().getMonth(), new Date().getDay())}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <FormControl fullWidth>
                                                    <TextValidator
                                                        label="Postcode"
                                                        name="postcode"
                                                        title="Postcode"
                                                        fullWidth
                                                        variant="outlined"
                                                        margin="normal"
                                                        value={this.state.model.postcode}
                                                        //)
                                                        onChange={this.handleChange}
                                                        validators={['isPostcodeValid', 'required']}
                                                        errorMessages={['Please enter a valid UK postcode', 'This field is required']}
                                                    />
                                                </FormControl>
                                            </Grid>
                                            <Grid item container justify="flex-end" spacing={2}>
                                                <Grid item xs={12} sm={5} md={5} className={classes.buttonItem}>
                                                    <Button type="submit" color="primary" variant="contained" className={classes.button} endIcon={<ArrowForward />} fullWidth>
                                                        Begin Enrolment
                                                        {this.state.saving && <CircularProgress color='secondary' size={24} className={this.props.classes.buttonProgress} />}
                                                    </Button>
                                                </Grid>


                                            </Grid>
                                        </React.Fragment>
                                    }
                                </Grid>
                            </ValidatorForm>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    }

    public handleAcademicYearChange = (event) => {
        if (this.state.model.academicYear !== event.target.value) {
            let newModel: EnrolmentWelcomeViewModel = this.state.model;
            newModel.academicYear = event.target.value;

            this.setState({ model: newModel });
        }
    }

    private handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const currModel: EnrolmentWelcomeViewModel = this.state.model;
        currModel[event.target.name] = event.target.value;

        if (event.target.name === "postcode") {
            if (event.target.value.split(' ').length === 2) {
                currModel.postcodeOut = event.target.value.split(' ')[0].toUpperCase();
                currModel.postcodeIn = event.target.value.split(' ')[1].toUpperCase();
            }
        }

        this.setState({ model: currModel });
    }

    private handleDateChange = (key, date) => {
        if (date !== null && date !== undefined && this.state.model[key] !== date) {

            const currModel: EnrolmentWelcomeViewModel = this.state.model;
            currModel[key] = new Date(date.toUTCString());

            this.setState({ model: currModel });
        }
    };

    //private fillTestDetails = () => {
    //    let newmodel = this.state.model;
    //    newmodel.academicYear = "20/21";
    //    newmodel.dateofBirth = new Date("2002-08-26");
    //    newmodel.studentReferenceNumber = "CRA18289637";
    //    newmodel.postcode = "HU4 7DG";
    //    newmodel.postcodeOut = "HU4";
    //    newmodel.postcodeIn = "7DG";
    //    this.setState({ model: newmodel });

    //}

    private save = (event) => {
        event.preventDefault();

        this.setState({ saving: true });

        fetch('api/Enrolment/FindLearner', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(this.state.model)
        }).then(response => response.json()).then((data) => {
            if (data !== null && data !== undefined) {
                const hasSubmittedFormRaw = data.hasSubmittedForm;
                const hasSubmittedForm = hasSubmittedFormRaw === true || hasSubmittedFormRaw === 1 || hasSubmittedFormRaw === "1";
                if (!hasSubmittedForm) {
                    this.props.setModel(data);
                    this.setState({ saving: false, studentNotFound: false, enrolmentAlreadyComplete: false });
                } else {
                    this.setState({ saving: false, studentNotFound: false, enrolmentAlreadyComplete: true });
                }
            } else {
                this.setState({ saving: false, studentNotFound: true, enrolmentAlreadyComplete: false });
                window.scrollTo(0, 0);
            }
        }).catch((error) => {
            this.setState({ saving: false, studentNotFound: true, enrolmentAlreadyComplete: false });
            window.scrollTo(0, 0);
        });
    }
}

export default withStyles(styles)(EnrolmentWelcome);

